/**
 * @components teacher-popup
 * @author 陈恩浩
 */

import React, { Component } from 'react'
import './index.scss'

class TeacherPopup extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {}

  handleClose = () => {
    this.props.callback(false)
  }

  render() {
    let { status } = this.props
    return (
      status && (
        <div className="teacher-popup">
          <div className="teacher-popup-layout">
            <div
              className="teacher-popup-close"
              onClick={this.handleClose}
            ></div>
            <div className="teacher-img"></div>
            <div className="teacher-content">
              <div className="teacher-name">
                吴 娟<img alt="teacher" />
              </div>
              <div className="teacher-basic">
                <span>中国</span>
                <span>浙江理工大学</span>
                <span>三年教学经验</span>
              </div>
              <div className="teacher-style">
                <span>教学风格</span>
                <span>
                  因材施教，善于引导、发现学生的亮点，培养学生的创新能力
                </span>
              </div>
            </div>
          </div>
        </div>
      )
    )
  }
}

export default TeacherPopup
